import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { Observable, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[spinner]',
})
export class NgxSpinnerDirective implements OnDestroy {
  destroySubject = new Subject<boolean>();

  spinnerComponentRef =
    this.container.createComponent<SpinnerComponent>(SpinnerComponent);

  @Input()
  set message(value: string) {
    this.spinnerComponentRef.setInput('message', value);
  }

  @Input('spinner')
  set showSpinner(spinning: boolean | Observable<boolean>) {
    if (spinning instanceof Observable) {
      setTimeout(() => {
        spinning
          .pipe(takeUntil(this.destroySubject))
          .subscribe((shouldSpin) => {
            if (shouldSpin) {
              this.show();
            } else {
              this.hide();
            }
          });
      }, 0);
    }
    if (spinning === true) {
      this.show();
    } else {
      this.hide();
    }
  }

  constructor(
    private container: ViewContainerRef,
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnDestroy(): void {
    this.destroySubject.next(true);
    this.destroySubject.complete();
  }

  hide() {
    this.renderer.removeChild(
      this.el.nativeElement,
      this.spinnerComponentRef.location.nativeElement
    );
  }

  show() {
    this.el.nativeElement.style.position = 'relative';
    this.renderer.appendChild(
      this.el.nativeElement,
      this.spinnerComponentRef.location.nativeElement
    );
  }
}
